<div
  class="border-m600 flex h-12 w-12 items-center justify-center rounded-full border-2"
>
  <svg
    class="text-m600 h-7 w-7"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 13l4 4L19 7"
    />
  </svg>
</div>
